import React from 'react';
import { Divider, Menu, MenuItem, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',  // shift anchor to left
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'left',  // open from left
        }}

        {...props}
    />
))(() => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: 0,
        minWidth: 130,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px,' +
            ' rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,' +
            ' rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,' +
            ' rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '0px 0px',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 8,
                color: 'black',
                marginRight: 8,
            },
        },
    },
}));



export default function CustomDropdownMenuButton({
    icon = <KeyboardArrowDownIcon />,
    menuItems = [],
    onItemClick = () => { },
    buttonProps = {},
    themecolors,
    selectedKey = "byGroup",
    style
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (item) => {
        setAnchorEl(null);
        if (item?.onClick) {
            item.onClick();
        }
        onItemClick(item);
    };

    return (
        <>
            <IconButton
                size="small"
                onClick={handleClick}
                aria-controls={open ? 'custom-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                sx={{
                    backgroundColor: themecolors?.themeLightColor,
                    padding: "0.09rem",
                    color: themecolors?.themeLightInverse,
                    '&:hover': {
                        backgroundColor: themecolors?.themeLightColor,
                    },
                }}
                {...buttonProps}
                style={style}
            >
                {icon}
            </IconButton>

            <StyledMenu
                id="custom-menu"
                MenuListProps={{ 'aria-labelledby': 'custom-icon-button' }}
                anchorEl={anchorEl}
                open={open}
                style={{ marginTop: "5px" }}
                onClose={() => handleClose(null)}
            >
                {menuItems.map((item, index) =>
                    item.divider ? (
                        <Divider key={index} sx={{ my: 0.1 }} />
                    ) : (
                        <MenuItem
                            key={index}
                            onClick={() => handleClose(item)}
                            disableRipple
                            disabled={item.disabled}
                            sx={{
                                margin:'4px 4px',
                                padding:"0.4rem",
                                fontSize:"0.9rem",
                                borderRadius:"4px",
                                ...(item.key === selectedKey && {
                                    color: themecolors?.themeLightInverse,
                                    backgroundColor: themecolors?.themeLightColor,
                                }),
                                '&:hover': {
                                    color: themecolors?.themeLightInverse,
                                    backgroundColor: themecolors?.themeLightColor,
                                },
                            }}
                        >
                            {item.icon && <item.icon sx={{ mr: 1 }} />}
                            {item.label}
                        </MenuItem>
                    )
                )}
            </StyledMenu>
        </>
    );
}
